enum ListViewType {
    List = 1,
    Table = 2
}

export default ListViewType;